import React, { useState } from 'react'
import { MySwal } from '../../../library/swal';
import axios from "../../../library/axios"
import Button from 'react-bootstrap/Button'
import { getSlug, } from "../../../../src/config/routes/guards/slug";
import { getApiErrorMessage } from '../../../helpers/apiErrorMessage';

const FormEditScorePokjaComp = (props) => {
    // console.log(props?.score)
    const [faktaAnalisis, setfaktaAnalisis] = useState(props?.score?.faktaAnalisis)
    const [skorPokja, setskorPokja] = useState(parseInt(props?.score?.Skor))
    const [skorSurveyorInternal, setskorSurveyorInternal] = useState('')

    const [loading, setLoading] = useState(false)
    const [disabled, setDisabled] = useState(false)

    const handleUpdatedScorePokja = () => {
        // setLoading(true)
        // setDisabled(true)

        const requestBody = {
            idKegiatanAkreditasi: props.IdKegiatanAkreditasi,
            idBab: props.IdBab,
            idVariable: props.IdVariable,
            faktaAnalisis: faktaAnalisis,
            Skor: skorPokja,
            skorSurveyor: skorSurveyorInternal,
            idUser: props.IdUser
        }
        // console.log(requestBody)
        // return false
        axios({
            url: `/skor/update/${props.score.id}`,
            method: 'PATCH',
            data: requestBody,
            headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
        })
            .then(res => {
                // console.log(res)
                // return false
                if (res.status === 200) {
                    MySwal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Berhasil menyimpan Skor Pokja!'
                    })

                    setLoading(false)
                    setDisabled(false)

                    props.fetch()
                    props.close()
                }
            })
            .catch(err => {
                setLoading(false)
                setDisabled(false)
                if (err !== "") {
                    console.log(err?.response)
                    MySwal.fire({
                        icon: 'error',
                        title: 'Oops, Error!',
                        text: getApiErrorMessage(err)
                    })
                }
            })
    }

    return (
        <>
            <div className="mb-3 row">
                <h6>Elemen Penilaian</h6>
                <div className="col-12">
                    <p className='text-info'>({props.element.Abjad}). {props.element.Deskripsi}</p>
                </div>
            </div>
            <hr></hr>
            <div className="mb-3 row">
                <label htmlFor="SkorPokja" className="col-sm-12 col-form-label required">Skor Pokja</label>
                <div className="col-12">
                    <select onChange={(e) => setskorPokja(e.target.value)} className='form-control' id='SkorPokja' value={skorPokja}>
                        <option value="">- Choose -</option>
                        <option value="TDD">TDD</option>
                        <option value="0">0</option>
                        <option value="5">5</option>
                        <option value="10">10</option>
                    </select>
                </div>
            </div>

            <div className="mb-3 row">
                <label htmlFor="FaktaAnalisis" className="col-sm-12 col-form-label">Fakta Analisis</label>
                <div className="col-12">
                    <textarea className='form-control' id='FaktaAnalisis' onChange={(e) => setfaktaAnalisis(e.target.value)} value={faktaAnalisis} rows={3}></textarea>
                </div>
                <small className='text-info'>Skor selain 10 wajib mengisi Fakta Analisis</small>
            </div>

            <div className="mt-5 row">
                <div className="col-12">
                    <Button variant="danger" size="sm" onClick={() => props.close()}>
                        Tutup
                    </Button>
                    &nbsp;
                    <Button disabled={disabled} variant="success" size="sm" onClick={() => handleUpdatedScorePokja()}>{loading === true ? 'Mohon Tunggu..' : 'Simpan'}</Button>
                </div>
            </div>
        </>
    )
}

export default FormEditScorePokjaComp
